import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const requireComponent = require.context(
  '@/shared/components', true, /\.vue$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  // Arquivos que são part de views e não são componentes, iniciciam com Part. Por isso a remoção com replace
  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, '').replace(/-/g, '') )
  )

  Vue.component(componentName, componentConfig.default || componentConfig)
})
